import React from "react";
import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import { observer, inject } from "mobx-react";
import { HelmetProvider } from "react-helmet-async";

// Page controllers
import { BirdHeaderHomepage } from "./components/layout/BirdHeaderHomepage";
import ProjectDefinitionPage from "./pages/ProjectDefinitionPage";
import { NavigatorPage } from "../src/pages/NavigatorPage";
import { SearchResultsPage } from "../src/pages/SearchResultsPage";

// Components
import Header from "./components/layout/Header";

// Utils
import { withParams, DetailViewPageWrapper } from "./utils/Utils";

const Router = !window?.__env?.USE_NEW_ROUTING ? HashRouter : BrowserRouter;

// Page controllers
const HomePage = React.lazy(() => import("./pages/HomePage"));
const BirdHomePage = React.lazy(() => import("./pages/BirdHomePage"));
const ContentManagementPage = React.lazy(() =>
  import("./pages/ContentManagementPage")
);
const DictionaryAdministratorPage = React.lazy(() =>
  import("./pages/DictionaryAdministratorPage")
);
const ProjectOwnerPage = React.lazy(() => import("./pages/ProjectOwnerPage"));
const MaintenanceAgencyOwnerPage = React.lazy(() =>
  import("./pages/MaintenanceAgencyOwnerPage")
);
const SystemAdministratorPage = React.lazy(() =>
  import("./pages/SystemAdministratorPage")
);
// const SearchResultsPage = React.lazy(() => import('./pages/SearchResultsPage'));
const MultiSearchPage = React.lazy(() =>
  import("./pages/MultiSearch/MultiSearchPage")
);
const VisContainer = React.lazy(() =>
  import("./components/vis/container/VisContainer")
);
const FrameworkNotYetInBirdPage = React.lazy(() =>
  import("./pages/FrameworkNotYetInBirdPage")
);

const NotificationCenterPage = React.lazy(() =>
  import("./pages/NotificationCenterPage/NotificationCenterPage")
);
const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

@inject("searchStore")
@observer
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isReady: false,
    };
  }
  componentDidMount() {
    const {
      fetchMetadata,
      fetchFrameworks,
      fetchSDDBusinessContent,
      fetchCubes,
    } = this.props.searchStore;
    if (IS_BIRD_APP) {
      Promise.all([fetchMetadata(), fetchFrameworks(), fetchCubes()]).then(
        () => {
          fetchSDDBusinessContent();
          this.setState({ isReady: true });
        }
      );
    } else {
      Promise.all([fetchMetadata(), fetchFrameworks()]).then(() => {
        fetchSDDBusinessContent();
        this.setState({ isReady: true });
      });
    }
  }

  render() {
    const { filtersVisible } = this.props.searchStore;
    const { isReady } = this.state;
    const detailViewPageWrapper = <DetailViewPageWrapper />;

    const routes = IS_BIRD_APP
      ? [
          <Route path="/" exact element={<BirdHomePage />} key="/" />,
          <Route
            path="/projectDefinition"
            exact
            element={<ProjectDefinitionPage />}
            key="/projectDefinition"
          />,
          <Route path="/nav" exact element={<NavigatorPage />} key="/nav" />,
          <Route
            path="/frameworksNotYetInBird"
            exact
            element={<FrameworkNotYetInBirdPage />}
            key="/frameworksNotYetInBird"
          />,
        ]
      : [
          <Route path="/" exact element={<HomePage />} key="/" />,
          <Route
            path="/da"
            exact
            element={<DictionaryAdministratorPage />}
            key="/da"
          />,
          <Route path="/po" exact element={<ProjectOwnerPage />} key="/po" />,
          <Route
            path="/mao"
            exact
            element={<MaintenanceAgencyOwnerPage />}
            key="/mao"
          />,
          <Route
            path="/sa"
            exact
            element={<SystemAdministratorPage />}
            key="/sa"
          />,
          <Route
            path="/notification"
            exact
            element={<NotificationCenterPage />}
            key="/notification"
          />,
        ];

    const commonRoutes = [
      <Route path="/cm" exact element={<ContentManagementPage />} key="/cm" />,
      <Route
        path="/search"
        exact
        element={<SearchResultsPage />}
        key="/search"
      />,
      <Route
        path="/view/:type/:tid"
        element={detailViewPageWrapper}
        key="/view/type/tid"
      />,
      <Route path="/vis" exact element={<VisContainer />} key="/vis" />,
      <Route
        path="/multisearch"
        exact
        element={<MultiSearchPage />}
        key="/multisearch"
      />,
    ];

    routes.push(commonRoutes);

    return isReady ? (
      <HelmetProvider>
        <Router>
          <React.Suspense fallback={<></>}>
            <React.Fragment>
              {IS_BIRD_APP ? <BirdHeaderHomepage /> : <Header />}
              <div
                id="main-content"
                className={`main-content ${
                  filtersVisible ? "showFilters" : ""
                }`}
              >
                <Routes>{routes}</Routes>
              </div>
            </React.Fragment>
          </React.Suspense>
        </Router>
      </HelmetProvider>
    ) : null;
  }
}

export default withParams(App);
